import moment from "moment-timezone";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Colors from "../utils/Colors";

const useStyles = createUseStyles((theme) => ({
  container: {
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderTop: `1px solid ${Colors.borderGray}`,
    borderLeft: `1px solid ${Colors.borderGray}`,
    backgroundColor: Colors.backgroundGray,
  },
  boxContainer: {
    display: "flex",
  },
  box: {
    flex: 1,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderBottom: `1px solid ${Colors.borderGray}`,
    borderRight: `1px solid ${Colors.borderGray}`,
  },
  boxRight: {
    textAlign: "right",
  },
  boxHeader: {
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "13px",
    lineHeight: "15px",
    textAlign: "center",
    color: Colors.primaryCharcoal,
  },
  bodyText: {
    color: Colors.primaryCharcoal,
    fontSize: "12px",
    lineHeight: "15px",
  },
}));

export default ({ period, name, tickets, className }) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classes.boxContainer}>
        <div className={classNames(classes.box, classes.boxHeader)}>
          <div className={classes.title}>{period}</div>
        </div>
      </div>
      <div className={classes.boxContainer}>
        <div className={classes.box}>
          <div className={classes.bodyText}>現在ご利用中のプラン</div>
        </div>
        <div className={classNames(classes.box, classes.boxRight)}>
          <div className={classes.bodyText}>{name}</div>
        </div>
      </div>
      <div className={classes.boxContainer}>
        <div className={classes.box}>
          <div className={classes.bodyText}>残りチケット数</div>
        </div>
        <div className={classNames(classes.box, classes.boxRight)}>
          <div className={classes.bodyText}>{tickets}</div>
        </div>
      </div>
    </div>
  );
};
